import { AresCompanyDetails } from '../../../services/ares/AresApiService.types'
import { getAresDetails } from '../../../services/ares/AresApiService'
import { useCallback, useState } from 'react'
import useAxios from '../../useAxios'

const useAresDetails = (onFetch?: (data: AresCompanyDetails) => void) => {
    const axios = useAxios()
    const [isLoading, setIsLoading] = useState(false)
    const [aresDetails, setAresDetails] = useState<AresCompanyDetails>()
    const [notFound, setNotFound] = useState(false)

    const resetAresDetails = useCallback(() => {
        setAresDetails(undefined)
        setNotFound(false)
    }, [])

    const fetchAresDetails = useCallback(async (companyId: string, throwError: boolean = true) => {
        setIsLoading(true)
        setNotFound(false)
        try {
            const response = await getAresDetails(axios, companyId)
            console.log(response)
            setNotFound(false)
            setAresDetails(response)
            onFetch?.(response)
            return response
        } catch (e) {
            setAresDetails(undefined)
            setNotFound(true)
            if (throwError) {
                return Promise.reject(e)
            }
        } finally {
            setIsLoading(false)
        }
    }, [axios, onFetch])
    
    return {
        isLoading,
        notFound,
        resetAresDetails,
        aresDetails,
        fetchAresDetails
    }
}

export default useAresDetails